import { S25Util } from "./s25-util";

export const EventSyncConst = {
    eventChange: "event-sync-event-change",
};

interface Detail {
    eventId: number;
    property: string;
    newValue: unknown;
}
interface StringUpdate extends Detail {
    property: "name" | "title";
    newValue: string;
}
interface NumberUpdate extends Detail {
    property: "state";
    newValue: number;
}

export type EventUpdate = StringUpdate | NumberUpdate;

export class EventSync {
    public static addEventListener(callback: (event: CustomEvent<EventUpdate>) => void) {
        window.addEventListener(EventSyncConst.eventChange, callback);
    }

    public static broadcastEventChange(eventId: string | number, property: string, newValue: string | number) {
        dispatchEvent(
            new CustomEvent(EventSyncConst.eventChange, {
                detail: {
                    eventId: S25Util.parseInt(eventId),
                    property: property,
                    newValue: newValue,
                },
            }),
        );
    }

    public static broadcastEventNameChange(eventId: string | number, newVal: string) {
        return EventSync.broadcastEventChange(eventId, "name", newVal);
    }

    public static broadcastEventTitleChange(eventId: string | number, newVal: string) {
        return EventSync.broadcastEventChange(eventId, "title", newVal);
    }

    public static broadcastEventStateChange(eventId: string | number, newVal: number) {
        return EventSync.broadcastEventChange(eventId, "state", newVal);
    }
}
